import _ from 'lodash';

export const formatAddress = (address) => {
    if (!address) return '';

    // Check if the address is all uppercase
    if (address === address.toUpperCase()) {
        // Convert to title case
        return address.toLowerCase()
            .split(' ')
            .map(word => {
                // Handle state abbreviations (2-letter codes that should stay uppercase)
                if (word.length === 2 && /^[A-Z]{2}$/i.test(word)) {
                    return word.toUpperCase();
                }
                // Handle ZIP codes (numeric codes that should stay as-is)
                if (/^\d+$/.test(word)) {
                    return word;
                }
                // Capitalize first letter of each word
                return word.charAt(0).toUpperCase() + word.slice(1);
            })
            .join(' ');
    }
    return address;
}

export const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';

    // Remove all non-digit characters
    const digits = phoneNumber.replace(/\D/g, '');

    // Format as (XXX) XXX-XXXX for 10 digits or +1 (XXX) XXX-XXXX for 11 digits
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length === 11 && digits.startsWith('1')) {
        return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }

    // Return original if it doesn't match expected patterns
    return phoneNumber;
};



export const formatBusinessName = (name) => {
    if (!name) return '';

    // Convert to title case with special handling for LLC/INC
    return _.chain(name)
        .toLower()
        .split(' ')
        .map(word => {
            // Special handling for LLC or INC - keep them uppercase
            if (word === 'llc' || word === '') {
                return _.toUpper(word);
            }
            // Capitalize first letter of each word
            return _.capitalize(word);
        })
        .join(' ')
        .value();
    return name;
}